import { createSlice } from "@reduxjs/toolkit";
import {
  toGetExternalPrograms,
  toAddProgramFamilyApplication,
  toGetProgramFamilyByProgramId,
  toCancelProgramRequest,
  toGetProgramRequests,
  toGetActivities,
  toGetProgramsBeneficiary,
  toGetProgramsCategories,
  toGetExternalProgramDetails,
  toRegisterProgramExternalRequest,
  toGetCompletedExternalPrograms,
  toGetProgramApplicationDetail,
} from "../actions/programs.actions";

const initialState = {
  TotalProgramsRequest: 0 as number,
  TotalPrograms: 0 as number,
  program: [] as any,
  programApplication: {
    data: [] as any,
    loading: false,
  },

  programs: [] as any,
  totalActivitiesPages: 0 as number,
  categories: [] as any,
  externalPrograms: {
    items: [] as any,
    loading: false,
    error: null as unknown | null,
  },
  completedExternalPrograms: [] as any,
  statuscompletedExternalPrograms: "idle" as string,
  programsBeneficiaries: {
    data: [] as any,
    loading: false,
  },
  addProgramsFamily: {
    data: {} as any,
    loading: false,
  },
  activities: [] as any,
  externalProgramDetails: null as any,
  registerRequest: {
    response: null as any,
    loading: false,
  },
  loading: false,
  isLoading: false,
  error: null as unknown | null,
  programRequest: {} as any,
};
export const programsSlice = createSlice({
  name: "programs",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    /*------------------GET PROGRAM REQUESTS------------------ */

    builder.addCase(toGetProgramRequests.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toGetProgramRequests.fulfilled, (state, action) => {
      state.program = action.payload.data;
      state.TotalProgramsRequest = action.payload.total_pages;
      state.loading = false;
    });
    builder.addCase(toGetProgramRequests.rejected, (state, action) => {
      state.TotalProgramsRequest = 0;
      state.program = [];
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(toGetProgramsBeneficiary.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toGetProgramsBeneficiary.fulfilled, (state, action) => {
      state.programs = action.payload.data;
      state.TotalPrograms = action.payload.total_pages;

      state.loading = false;
    });
    builder.addCase(toGetProgramsBeneficiary.rejected, (state, action) => {
      state.TotalPrograms = 0;
      state.programs = [];
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(toGetProgramsCategories.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toGetProgramsCategories.fulfilled, (state, action) => {
      state.categories = action.payload;
      state.loading = false;
    });
    builder.addCase(toGetProgramsCategories.rejected, (state, action) => {
      state.categories = [];
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(toGetExternalPrograms.pending, (state) => {
      state.externalPrograms.loading = true;
    });
    builder.addCase(toGetExternalPrograms.fulfilled, (state, action) => {
      state.externalPrograms.items = action.payload;
      state.externalPrograms.loading = false;
    });
    builder.addCase(toGetExternalPrograms.rejected, (state, action) => {
      state.externalPrograms.items = [];
      state.externalPrograms.loading = false;
      state.error = action.payload;
    });

    builder.addCase(toGetExternalProgramDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toGetExternalProgramDetails.fulfilled, (state, action) => {
      state.externalProgramDetails = action.payload;
      state.loading = false;
    });
    builder.addCase(toGetExternalProgramDetails.rejected, (state, action) => {
      state.externalProgramDetails = {};
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(toGetCompletedExternalPrograms.pending, (state) => {
      state.statuscompletedExternalPrograms = "idle";
    });
    builder.addCase(
      toGetCompletedExternalPrograms.fulfilled,
      (state, action) => {
        state.completedExternalPrograms = action.payload;
        state.statuscompletedExternalPrograms = "succeeded";
      }
    );
    builder.addCase(
      toGetCompletedExternalPrograms.rejected,
      (state, action) => {
        state.completedExternalPrograms = "rejected";
        state.loading = false;
        state.error = action.payload;
      }
    );

    builder.addCase(toRegisterProgramExternalRequest.pending, (state) => {
      state.registerRequest.loading = true;
    });
    builder.addCase(
      toRegisterProgramExternalRequest.fulfilled,
      (state, action) => {
        state.registerRequest.response = action?.payload;
        state.registerRequest.loading = false;
      }
    );
    builder.addCase(
      toRegisterProgramExternalRequest.rejected,
      (state, action) => {
        state.registerRequest.response = {};
        state.registerRequest.loading = false;
        state.error = action.payload;
      }
    );
    builder.addCase(toGetProgramFamilyByProgramId.pending, (state) => {
      state.programsBeneficiaries.loading = true;
    });
    builder.addCase(
      toGetProgramFamilyByProgramId.fulfilled,
      (state, action) => {
        state.programsBeneficiaries.data = action?.payload?.data?.result;
        state.programsBeneficiaries.loading = false;
      }
    );
    builder.addCase(toGetProgramFamilyByProgramId.rejected, (state, action) => {
      state.programsBeneficiaries.data = [];
      state.programsBeneficiaries.loading = false;
      state.error = action.payload;
    });

    builder.addCase(toAddProgramFamilyApplication.pending, (state) => {
      state.addProgramsFamily.loading = true;
    });
    builder.addCase(
      toAddProgramFamilyApplication.fulfilled,
      (state, action) => {
        state.addProgramsFamily.data = action?.payload;
        state.addProgramsFamily.loading = false;
      }
    );
    builder.addCase(toAddProgramFamilyApplication.rejected, (state, action) => {
      state.addProgramsFamily.data = [];
      state.addProgramsFamily.loading = false;
      state.error = action.payload;
    });
    /*------------------Cancel PROGRAM REQUEST------------------ */

    builder.addCase(toCancelProgramRequest.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(toCancelProgramRequest.fulfilled, (state, action) => {
      state.programRequest = action?.payload;
      state.isLoading = false;
    });
    builder.addCase(toCancelProgramRequest.rejected, (state, action) => {
      state.programRequest = {};
      state.isLoading = false;
      state.error = action.payload;
    });
    /*------------------GET ACTIVITIES------------------ */
    builder.addCase(toGetActivities.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toGetActivities.fulfilled, (state, action) => {
      state.activities = action.payload?.data;
      state.totalActivitiesPages = action.payload?.total_pages;
      state.loading = false;
    });
    builder.addCase(toGetActivities.rejected, (state, action) => {
      state.activities = [];
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(toGetProgramApplicationDetail.pending, (state) => {
      state.programApplication.loading = true;
    });
    builder.addCase(
      toGetProgramApplicationDetail.fulfilled,
      (state, action) => {
        state.programApplication.data = action?.payload;
        state.programApplication.loading = false;
      }
    );
    builder.addCase(toGetProgramApplicationDetail.rejected, (state, action) => {
      state.programApplication.data = [];
      state.programApplication.loading = false;
      state.error = action.payload;
    });
  },
});

export default programsSlice.reducer;
